/**
 * @generated SignedSource<<684f8d3206a7eb9c69fa408fd826c4c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternBrandOnboarding_brand$data = {
  readonly domain: string;
  readonly id: string;
  readonly " $fragmentType": "InternBrandOnboarding_brand";
};
export type InternBrandOnboarding_brand$key = {
  readonly " $data"?: InternBrandOnboarding_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternBrandOnboarding_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternBrandOnboarding_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "domain",
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "45aade556ae3674aab0f0d1e8f97e86c";

export default node;
